<template>
  <li :class="item_class">
    <router-link
      :to="item.route"
      :class="{
        'sidebar-menu__item-link': true,
        'inactive-item': current_open
      }"
    >
      <template v-if="item.icon">
        <div :is="item.icon" :key="`${item.name}-${item.route}`" class="sidebar-menu__item-icon" />
      </template>
      {{ $t(item.title) }}
    </router-link>
  </li>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: function() {
          return {
            name: '',
            title: '',
            icon_class: '',
            route: ''
          };
        }
      },
      current_open: {
        type: String,
        default: ''
      }
    },

    computed: {
      is_active() {
        return this.$route.matched.some(m => m.name == this.item.name) && !this.current_open;
      },
      item_class() {
        return {
          'sidebar-menu__item': true,
          'sidebar-menu__item--active': this.is_active
        };
      }
    }
  };
</script>

<style lang="scss">
  // fix !important modifier later
  .inactive-item {
    color: $header-color !important;
    background-color: transparent !important;
  }
</style>
